/**
 * Events du tunnel NeverZero, envoyés au projet PostHog dédié (snippet dans
 * `index.html`, qui pose `window.posthog`).
 *
 * Jamais d'appel côté serveur : ce module est importé par des composants rendus
 * en SSR, d'où le garde sur `window`. Si le script PostHog est bloqué (adblock),
 * l'appel ne fait rien : la mesure ne doit jamais casser le tunnel de paiement.
 *
 * Aucune donnée saisie ne part dans les propriétés : ni l'URL LinkedIn, ni
 * l'email. On mesure le parcours, pas la personne.
 */

type AnalyticsEvent =
  | 'checkout_form_submitted'
  | 'checkout_url_invalid'
  | 'checkout_redirected'
  | 'checkout_failed'
  | 'checkout_completed'
  | 'call_cta_clicked'
  | 'call_page_viewed'
  | 'call_slot_selected'
  | 'call_booked'
  | 'call_booking_failed'
  | 'call_callback_opened'
  | 'call_callback_requested'
  | 'call_callback_failed'
  | 'method_video_played'
  | 'white_label_page_viewed';

interface PostHogLike {
  capture: (event: string, properties?: Record<string, unknown>) => void;
}

export function track(event: AnalyticsEvent, properties?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;
  try {
    (window as unknown as { posthog?: PostHogLike }).posthog?.capture(event, properties);
  } catch {
    // Un analytics en panne ne doit pas interrompre le visiteur.
  }
}
